import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../types'
import { CmsConverterService } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class MacsimaArtToolConverter extends CmsConverterService<MacsimaArtToolData> {
  convertData (source: CmsComponent) {
    return {}
  }
}

export const MACSIMA_ART_TOOL_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, MacsimaArtToolData>>('MacsimaArtToolConverter')

export type MacsimaArtToolData = ConvertedComponentData

